import Vue from "vue";
import Vuex from "vuex";
import authModule from "./modules/auth";
import usersModule from "./modules/users";
import serviceModule from "./modules/services";
import expenseModule from "./modules/expenses";
import reportsModule from "./modules/reports";
import receptionist from "./modules/receptionist";
import employeeModule from "./modules/employee";
import employeeDoctors from "./modules/doctors";
import bussinessModule from "./modules/bussiness";

Vue.use(Vuex);

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    auth: authModule,
    user: usersModule,
    services: serviceModule,
    expenses: expenseModule,
    reports: reportsModule,
    receptionist: receptionist,
    employee: employeeModule,
    doctors: employeeDoctors,
    bussiness: bussinessModule
  },
  state: {
    isNavOpen: true,
    loading: false,
    message: ""
  },
  mutations: {
    setIsNavOpen(state) {
      state.isNavOpen = !state.isNavOpen;
      localStorage.setItem("isSidebarOpen", JSON.stringify(state.isNavOpen));
    },
    setNavOpenState(state, isOpen) {
      state.isNavOpen = isOpen;
      localStorage.setItem("isSidebarOpen", JSON.stringify(isOpen));
    },
    initialiseStore(state) {
      if (localStorage.getItem("isSidebarOpen") !== null) {
        state.isNavOpen = JSON.parse(localStorage.getItem("isSidebarOpen"));
      }
    },
    set_loading(state, val) {
      state.loading = val;
    },
    set_message(state, val) {
      state.message = val;
    }
  },
  actions: {
    toggleNav({ commit }) {
      commit("setIsNavOpen");
    },
    handleLoading({ commit }) {
      commit("set_loading", true);
    }
  },
  getters: {
    isNavOpen: state => state.isNavOpen,
    loading: state => state.loading
  }
});

export default store;
